module.exports = __webpack_public_path__ + "img/icon_flag_hk@3x.73b3dab4.png";